import { render, staticRenderFns } from "./BranchOfficeCard.vue?vue&type=template&id=0147b268&scoped=true"
import script from "./BranchOfficeCard.vue?vue&type=script&lang=js"
export * from "./BranchOfficeCard.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0147b268",
  null
  ,true
)

export default component.exports